var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{attrs:{"controls":_vm.controls,"autoplay":_vm.autoplay,"width":_vm.width,"height":_vm.height},domProps:{"muted":_vm.muted}},[_c('source',{attrs:{"src":_vm.host+_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }